import HamburgerMenu from '../../atoms/icons/HamburgerMenu';
import styles from './HeaderNavigation.module.scss';
import DesktopMenu from '@srcDS/components/molecules/headerMenu/desktopMenu/DesktopMenu';
import MobileMenu from '@srcDS/components/molecules/headerMenu/mobileMenu/MobileMenu';

import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isTouchDevice } from '@srcDS/utils/assertions';
import { useMenuContext } from '@srcDS/provider/menu/MenuContext';

export const HeaderNavigation = ({
  isMobile,
  isInvertedClass,
  locales = [],
  categories = [],
  storeLocatorLink,
  isSSR,
  contentfulNavigationTiles,
}) => {
  const isLoggedIn = useSelector((state) => state.app?.context?.session?.loggedIn || false);

  const { setIsTouch, shownMenu, setShownMenu, getVisibleCategories } = useMenuContext();

  useEffect(() => {
    if (!isSSR) {
      setIsTouch(isTouchDevice());
    }
  }, [isSSR]);

  const openMenu = () => {
    try {
      window?.zE && window?.zE('messenger:set', 'zIndex', 1);
    } catch (e) {
      console.log(e);
    }
    setShownMenu(true);
  };

  const visibleCategories = getVisibleCategories(categories, isLoggedIn);
  return (
    <div className={clsx(styles.headerNavigation, isMobile && styles.headerNavigationForTouch)}>
      <div className={clsx(styles.headerNavigationItem, styles.menu)}>
        <div className={styles.category}>
          <DesktopMenu categories={visibleCategories} isInvertedClass={isInvertedClass} />
        </div>
        <div className={clsx(styles.menuIcon, isInvertedClass)}>
          <HamburgerMenu onClick={openMenu} data-mobile-menu="mobile_menu" />
        </div>
      </div>
      <div className={clsx(styles.mobileMenu, shownMenu && styles.active)}>
        <MobileMenu
          setShownMenu={setShownMenu}
          categories={visibleCategories}
          locales={locales}
          shownMenu={shownMenu}
          storeLocatorLink={storeLocatorLink}
          contentfulNavigationTiles={contentfulNavigationTiles}
        />
      </div>
    </div>
  );
};
